import { useState, useEffect, useRef } from 'react';
import {
  AppBar,
} from '@mui/material';
import './VizzleAppbar.scss';
import ObjectUtils from '../../utils/ObjectUtils';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

/**
 * App bar of the application that automatically adjust the height
 * of the content
 */
const defaultProps = {
  appbarPosition: 'top',
  onAppbarChangeSize: () => {},
};

export default function VizzleAppBar(props) {
  const {
    children,
    appbarPosition,
    onAppbarChangeSize,
    ...rest
  } = { ...defaultProps, ...filterUndefined(props) };
  const [appBarState, setAppBarState] = useState({
    height: 100,
  });

  const appBarRefEl = useRef(null);

  useEffect(() => {
    if (appBarRefEl && appBarRefEl.current) {
      ObjectUtils.setTimeout(() => {
        setAppBarState({
          ...appBarState,
          height: appBarRefEl.current.clientHeight || 100,
        });
        onAppbarChangeSize?.(appBarRefEl.current.clientHeight);
      }, 100);
    }
    // eslint-disable-next-line
  }, [appBarRefEl.current]);

  const appbarPositionClass = {
    top: 'vizzle-app-bar-position-top',
    bottom: 'vizzle-app-bar-position-bottom',
  };

  const appbarPositionContainerClass = {
    top: '',
    bottom: 'vizzle-app-bar-container-position-bottom',
  };

  return (
    <div
      style={{ height: appBarState.height, minHeight: appBarState.height }}
      className={`vizzle-app-bar-position-component ${appbarPositionContainerClass[appbarPosition]}`}
    >
      <AppBar
        ref={appBarRefEl}
        position='fixed'
        color='default'
        className={appbarPositionClass[appbarPosition]}
        {...rest}
      >
        {children}
      </AppBar>
    </div>
  );
}
